"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Layout = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n\n  @media only screen and (max-width: 800px) {\n    flex-flow: column-reverse;\n  }\n"], ["\n  display: flex;\n\n  @media only screen and (max-width: 800px) {\n    flex-flow: column-reverse;\n  }\n"])));
var LeftPanel = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 350px;\n  min-width: 350px;\n  border-right: 1px solid #d5e1eb;\n\n  @media only screen and (max-width: 800px) {\n    width: 100%;\n  }\n"], ["\n  width: 350px;\n  min-width: 350px;\n  border-right: 1px solid #d5e1eb;\n\n  @media only screen and (max-width: 800px) {\n    width: 100%;\n  }\n"])));
var Children = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var SubjectDetailLayout = function (_a) {
    var panel = _a.panel, children = _a.children, footer = _a.footer;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(Layout, null,
            react_1.default.createElement(LeftPanel, null, panel),
            react_1.default.createElement(Children, null, children)),
        footer));
};
SubjectDetailLayout.defaultProps = {
    footer: undefined,
};
exports.default = SubjectDetailLayout;
var templateObject_1, templateObject_2, templateObject_3;
